import { GLOFOX_REQUEST_ACCESS_HREF } from "@/lib/portal/glofox-routes";

export const AUTH_RETURN_PATH_STATE_KEY = "from";

export const REQUEST_ACCESS_AUTH_NOTICE =
  "Log in or sign up to request API access.";

export function resolvePostAuthRedirect(from: unknown): string {
  if (typeof from !== "string") {
    return "/";
  }

  const trimmed = from.trim();
  if (!trimmed.startsWith("/") || trimmed.startsWith("//")) {
    return "/";
  }

  return trimmed;
}

export function getRequestAccessAuthNotice(from: unknown): string | null {
  return resolvePostAuthRedirect(from) === GLOFOX_REQUEST_ACCESS_HREF
    ? REQUEST_ACCESS_AUTH_NOTICE
    : null;
}

export function readAuthReturnPath(state: unknown): unknown {
  if (!state || typeof state !== "object") {
    return undefined;
  }

  return (state as Record<string, unknown>)[AUTH_RETURN_PATH_STATE_KEY];
}
